/**
 * Convenience accessor for RTK Query hooks
 * Pattern matches restohub-frontend admin
 *
 * Usage:
 *   import { menuWidgetApi } from '@/store/convenienceAccessor'
 *   const { data } = menuWidgetApi.menuConfig.get({ restaurant_id: '...' })
 *   const [submitOrder] = menuWidgetApi.orderSubmit.add()
 */

import { api } from './api'
import { apiEndpoints } from './endpointsConfig'

// Action to hook name mapping
const actionHookName = (action: string, name: string): string => {
  const capitalizedName = name.charAt(0).toUpperCase() + name.slice(1)
  switch (action) {
    case 'POST':
      return `useAdd${capitalizedName}Mutation`
    case 'PATCH':
      return `usePatch${capitalizedName}Mutation`
    case 'PUT':
      return `useUpdate${capitalizedName}Mutation`
    case 'DELETE':
      return `useDelete${capitalizedName}Mutation`
    case 'LIST':
      return `useList${capitalizedName}Query`
    case 'GET':
      return `useGet${capitalizedName}Query`
    default:
      return ''
  }
}

const actionsNames: Record<string, string> = {
  POST: 'add',
  PATCH: 'patch',
  DELETE: 'delete',
  PUT: 'update',
  LIST: 'list',
  GET: 'get',
}

// Dynamically generate convenience accessor object
const generateConvenienceAccessor = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const accessor: Record<string, Record<string, any>> = {}

  apiEndpoints.forEach((endpoint) => {
    const { name: entityName, actions } = endpoint
    const capitalizedName = entityName.charAt(0).toUpperCase() + entityName.slice(1)

    // Initialize entity accessor
    accessor[entityName] = {}

    // Add hooks for each configured action
    actions.forEach((action) => {
      const hookName = actionHookName(action, capitalizedName)
      const apiRecord = api as unknown as Record<string, unknown>
      if (hookName && apiRecord[hookName]) {
        accessor[entityName][actionsNames[action]] = apiRecord[hookName]
      }
    })
  })

  return accessor
}

export const menuWidgetApi = generateConvenienceAccessor()

// Also export the raw api for reducer setup
export { api }
